/** No credentials are persisted. A scope-local signal reloads other ERP tabs. */
export const ERP_SESSION_CHANGE = "cloudcat:erp-session-change";
export function announceErpSessionChange() {
  try {
    localStorage.setItem(ERP_SESSION_CHANGE, crypto.randomUUID());
  } catch {
    /* Storage may be disabled. */
  }
}
